module.exports = __webpack_public_path__ + "assets/images/hrsc-logo_37c06d6c38154867a1dd873535760a3b.png";